let initialStepData = {
  fullName: '',
  aadhar: '',
  photo: null,
  fileName:'',
  imagePreviewUrl:'',
  siblings: false,
  dateOfBirth: '',
  class: '',
  birthPlace: '',
  nationality: '',
  religion: '',
  motherTongue: '',
  gender: '',
  sibling1Name: '',
  sibling2Name: '',
  sibling1Class: '',
  sibling2Class: '',
  sibling1Section: '',
  sibling2Section: '',
  physical: '',
  stream:'',
  option: '',
  transport: '',
  application_id: '',
};

export default initialStepData;
